__turbopack_context__.v({
  "h1": "H1-module-sass-module__nG8KVW__h1",
  "h1--multiline": "H1-module-sass-module__nG8KVW__h1--multiline",
  "h1__input": "H1-module-sass-module__nG8KVW__h1__input",
  "h1__label": "H1-module-sass-module__nG8KVW__h1__label",
  "h1__label--filled": "H1-module-sass-module__nG8KVW__h1__label--filled",
});
